import type { Animal } from "../data/animals";
import { DrawingThumb } from "./DrawingThumb";
import { useLocale, useT } from "../i18n/LocaleProvider";
import { genderOf } from "../i18n/localize";

interface Props {
  animal: Animal;
  /** Whether the child has already finished this drawing. */
  done: boolean;
  /** Optional small line under the name (e.g. "by Van Gogh"). */
  subtitle?: string;
  onClick: () => void;
}

/** A big tappable card showing the finished drawing + name. */
export function AnimalCard({ animal, done, subtitle, onClick }: Props) {
  const t = useT();
  const { locale } = useLocale();
  // `animal` arrives already localized; its id still keys the gender table.
  const gender = genderOf(animal.id, locale);
  return (
    <button
      className={done ? "card done" : "card"}
      onClick={onClick}
      aria-label={
        done
          ? t.cardDrawDoneAria(gender, animal.name)
          : t.cardDrawAria(gender, animal.name)
      }
    >
      {done && (
        <span className="card-check" aria-hidden="true">
          ✓
        </span>
      )}
      <DrawingThumb animal={animal} className="card-preview" />
      <span className="card-name">
        {animal.emoji} {animal.name}
      </span>
      {subtitle && <span className="card-sub">{subtitle}</span>}
    </button>
  );
}
